import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-text.css';
import { EGDSTypeAlignments, EGDSTypeMargins, EGDSTypeOverflows, EGDSTypeHyphens, EGDSTypeSizes, EGDSTypeWeights, EGDSTypeWhiteSpaces, EGDSTextThemes } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * Use for freestanding text elements that are not a list, paragraph, or heading.
 * Should not replace the usage of lists or headings.
 */
const EGDSText = props => {
  const {
    align,
    children,
    inline,
    size: passedInSize,
    spacing,
    overflow,
    weight,
    whiteSpace,
    className,
    theme = 'default',
    wordBreak = false,
    dataTestId,
    hyphens,
    typeStyle,
    ...attributes
  } = props;
  const isPhraseTag = inline && typeof inline === 'string';
  const size = !isPhraseTag && !passedInSize ? 300 : passedInSize;
  let Tag;
  if (inline && typeof inline === 'boolean') {
    Tag = 'span';
  } else if (isPhraseTag) {
    Tag = inline;
  } else {
    Tag = 'div';
  }
  const {
    data: contextData
  } = useEGDSContext();
  const {
    bottomScrimContext,
    overlayScrimContext,
    contextClassNames
  } = contextData ?? {};
  const wrapperClassNames = getClassNameList('uitk-text', align && EGDSTypeAlignments.get(align), spacing && EGDSTypeMargins.get(spacing), overflow && !inline && EGDSTypeOverflows.get(overflow), wordBreak && !inline && EGDSTypeOverflows.get('wrap'), hyphens && EGDSTypeHyphens.get(hyphens), !bottomScrimContext && size && EGDSTypeSizes.get(size), !bottomScrimContext && weight && EGDSTypeWeights.get(weight), whiteSpace && EGDSTypeWhiteSpaces.get(whiteSpace), bottomScrimContext && `in-bottom-scrim`, overlayScrimContext && `in-overlay-scrim`, !(bottomScrimContext || overlayScrimContext) && theme && EGDSTextThemes.get(theme), contextClassNames?.EGDSText, className, typeStyle && `uitk-type-style-${typeStyle.customStyle}`);
  return children ? jsx(Tag, {
    className: wrapperClassNames,
    ...(dataTestId ? {
      'data-test-id': dataTestId
    } : {}),
    ...(typeStyle && {
      'type-style-theme': typeStyle.customTheme || 'standard'
    }),
    ...attributes,
    children: children
  }) : null;
};
EGDSText.displayName = 'EGDSText';
export { EGDSText };